const getMfaSettingsSuccess = (data) => ({
  type: 'GET_MFA_SETTINGS_SUCCESS',
  data
});

export const mutation = {
  getMfaSettingsSuccess
};
